import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1247728440775020';
export function initMetaPixel() {
  if (typeof window === 'undefined') return;
  if ((window as any).fbq) return;
  const f = window as any;
  const b = document;
  const e = 'script';
  const v = 'https://connect.facebook.net/en_US/fbevents.js';
  const n: any = f.fbq = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = b.createElement(e) as HTMLScriptElement;
  t.async = true;
  t.src = v;
  const s = b.getElementsByTagName(e)[0];
  s?.parentNode?.insertBefore(t, s);
  f.fbq('init', PIXEL_ID);
  f.fbq('track', 'PageView');
}
export const MetaPixel = () => {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <noscript data-id="element-110">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-111" />
    </noscript>;
};